import axios from 'axios';
import { Toast } from 'vant';

// const { protocol } = window.location;

const service = axios.create({
  baseURL: `http://parcloud.fengliansheng.com/spot/mobile`,
  // baseURL: `http://bjflscs.cvoon.com/spot/mobile`,
  withCredentials: true,
  timeout: 6000,
});

service.interceptors.request.use(request => {
  const spotId = window.sessionStorage.getItem('spotId');
  const { method } = request;
  if (method === 'get') {
    return {
      ...request,
      params: {
        spot_id: spotId,
        ...request.params,
      },
    };
  }
  return {
    ...request,
    data: {
      spot_id: spotId,
      ...request.data,
    },
  };
});

service.interceptors.response.use(
  response => {
    const { code, data } = response.data;
    if (code === 200) return data;
    if (code === 401) window.location.href = data;
    if (code === 400) {
      Toast.fail(response.data.msg);
      return false;
    }
    return false;
  },
  error => Promise.reject(error)
);

export default service;
